<!--
 * @Descripttion: 
 * @version: 
 * @Author: Raoxf
 * @Date: 2020-09-03 10:17:43
 * @LastEditors: Raoxf
 * @LastEditTime: 2023-04-08 08:56:41
-->
<template>
  <div class="page-order-detail">
    <el-descriptions class="margin-top" title="订单详情" :column="2" border>
      <el-descriptions-item>
        <template slot="label">
          <i class="el-icon-user"></i>
          订单编号
        </template>
        {{ orderInfo.orderNum }}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">
          <i class="el-icon-user"></i>
          下单时间
        </template>
        {{ orderInfo.createDt }}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">
          <i class="el-icon-user"></i>
          姓名
        </template>
        {{ orderInfo.consignee }}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">
          <i class="el-icon-mobile-phone"></i>
          手机号
        </template>
        {{ orderInfo.phone }}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">
          <i class="el-icon-location-outline"></i>
          地址信息
        </template>
        <p>地点：{{ orderInfo.address }}</p>
        <!-- <p>地址类型：{{ orderInfo.addressType }}</p>
        <p>面积： {{ orderInfo.area }}</p> -->
        <!-- <p>备注：{{ orderInfo.attention }}</p> -->
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">
          <i class="el-icon-location-outline"></i>
          订单信息
        </template>
        <p>总计：{{ orderInfo.totalPrice }}元</p>
        <p>优惠：{{ orderInfo.discount || 0 }}元</p>
        <p>实付款：{{ orderInfo.actualPayment }}元</p>
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">
          <i class="el-icon-location-outline"></i>
          备注
        </template>
        <p>{{ orderInfo.backup }}</p>
      </el-descriptions-item>
    </el-descriptions>
    <el-descriptions
      class="margin-top mt-20"
      title="更多信息"
      :column="2"
      border
    >
      <el-descriptions-item>
        <template slot="label">
          <i class="el-icon-time"></i>
          预约时间
        </template>
        {{ orderInfo.appointmentTime || "-" }}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">
          <i class="el-icon-s-order"></i>
          是否购买订单险
        </template>
        {{ orderInfo.isOrderInsurance == 1 ? "是" : "否" }}
      </el-descriptions-item>
      <!-- <el-descriptions-item>
        <template slot="label">
          <i class="el-icon-location"></i>
          经纬度
        </template>
        {{ orderInfo.latitude || "-" }}, {{ orderInfo.longitude || "-" }}
      </el-descriptions-item> -->
      <!-- <el-descriptions-item>
        <template slot="label">
          <i class="el-icon-document"></i>
          订单ID
        </template>
        {{ orderInfo.orderId || "-" }}
      </el-descriptions-item> -->
      <el-descriptions-item>
        <template slot="label">
          <i class="el-icon-ticket"></i>
          优惠券ID
        </template>
        {{ orderInfo.couponId || "-" }}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">
          <i class="el-icon-collection"></i>
          订单类型
        </template>
        {{ typeMap[orderInfo.type] || "-" }}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">
          <i class="el-icon-user"></i>
          服务人员姓名
        </template>
        {{ orderInfo.serviceUserName || "-" }}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">
          <i class="el-icon-user"></i>
          服务人员手机号
        </template>
        {{ orderInfo.serviceUserPhone || "-" }}
      </el-descriptions-item>
      <!-- <el-descriptions-item>
        <template slot="label">
          <i class="el-icon-s-custom"></i>
          用户类型
        </template>
        {{ orderInfo.userType || "-" }}
      </el-descriptions-item> -->
      <el-descriptions-item>
        <template slot="label">
          <i class="el-icon-goods"></i>
          商品名称
        </template>
        {{ orderInfo.productName || "-" }}
        {{ orderInfo.categoryName || "-" }}
      </el-descriptions-item>
      <!-- <el-descriptions-item>
        <template slot="label">
          <i class="el-icon-price-tag"></i>
          商品种类ID
        </template>
        {{ orderInfo.productCategoryId || "-" }}
      </el-descriptions-item> -->
      <el-descriptions-item>
        <template slot="label">
          <i class="el-icon-picture"></i>
          封面
        </template>
        <el-popover
          placement="right"
          trigger="hover"
          width="220"
          v-if="orderInfo.cover"
        >
          <img :src="orderInfo.cover" width="200" />
          <img
            slot="reference"
            :src="orderInfo.cover"
            style="height: 40px; width: 40px"
          />
        </el-popover>
        <span v-else>-</span>
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">
          <i class="el-icon-time"></i>
          服务开始时间
        </template>
        {{ orderInfo.startDt || "-" }}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">
          <i class="el-icon-time"></i>
          服务结束时间
        </template>
        {{ orderInfo.endDt || "-" }}
      </el-descriptions-item>
      <!-- <el-descriptions-item>
        <template slot="label">
          <i class="el-icon-time"></i>
          最近更新时间
        </template>
        {{ orderInfo.updateDt || "-" }}
      </el-descriptions-item> -->
      <el-descriptions-item>
        <template slot="label">
          <i class="el-icon-coin"></i>
          打赏金额
        </template>
        {{ orderInfo.tipNum || "-" }}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">
          <i class="el-icon-s-flag"></i>
          订单状态值
        </template>
        {{
          orderInfo.state
            ? stateList.filter((list) => list.value == orderInfo.state)[0].label
            : ""
        }}
      </el-descriptions-item>
    </el-descriptions>
    <div v-for="item in orderInfo.orderProductBoList" v-bind:key="item.id">
      <el-descriptions class="margin-top mt-20" :column="2" border>
        <el-descriptions-item>
          <template slot="label">
            <i class="el-icon-user"></i>
            服务信息
          </template>
          <div class="d-flex">
            <p>{{ item.productName }}</p>
          </div>
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            <i class="el-icon-user"></i>
            订单状态
          </template>
          <span style="color: red">{{
            item.status
              ? stateList.filter((list) => list.value == item.status)[0].label
              : ""
          }}</span>
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            <i class="el-icon-user"></i>
            预约服务时间
          </template>
          {{
            item.cleanerServiceLogList[0]
              ? item.cleanerServiceLogList[0].appointmentDt
              : "-"
          }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            <i class="el-icon-location-outline"></i>
            订单信息
          </template>
          <p>单价：{{ item.productUnitPrice }}元</p>
          <p>数量：{{ item.productNum }}</p>
          <p>实付款：{{ item.productActualPayment }}元</p>
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            <i class="el-icon-location-outline"></i>
            剩余次数
          </template>
          <p>{{ item.noAppointmentsNum }}次</p>
        </el-descriptions-item>
        <el-descriptions-item
          v-for="(cleanInfo, index) in item.cleanerServiceLogList"
          v-bind:key="cleanInfo.id"
        >
          <template slot="label">
            <i class="el-icon-location-outline"></i>
            第{{ index + 1 }}次服务保洁员信息
          </template>
          <p>姓名：{{ cleanInfo.cleanerName }}</p>
          <p>手机号：{{ cleanInfo.cleanerPhone }}</p>
          <p>所属公司：{{ cleanInfo.companyName || "-" }}</p>
          <p v-if="cleanInfo.startAddress">
            服务开始地点：{{ cleanInfo.startAddress }}
          </p>
          <p v-if="cleanInfo.endAddress">
            服务结束地点：{{ cleanInfo.endAddress }}
          </p>
          <p>服务开始时间：{{ cleanInfo.startDt }}</p>
          <p>服务结束时间：{{ cleanInfo.endDt }}</p>
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            <i class="el-icon-location-outline"></i>
            操作
          </template>
          <el-button
            type="primary"
            size="small"
            v-if="item.service_user_id && !item.start_dt"
            @click="onDispatch(item, 1)"
          >
            转单
          </el-button>
          <el-button
            type="primary"
            size="small"
            v-if="!item.service_user_id && orderInfo.state == 2"
            @click="onDispatch(item, 1)"
          >
            派单
          </el-button>
          <el-button
            type="primary"
            size="small"
            @click="onDispatch(item, 2)"
            v-if="[1, 2, 3, 6].includes(item.state) && !isCompany"
          >
            取消订单
          </el-button>
        </el-descriptions-item>
      </el-descriptions>
    </div>
    <div class="btn-content" v-if="orderInfo.state == 5 && !isCompany">
      <el-button type="primary" size="small" @click="handleAgreeRefund"
        >同意退款</el-button
      >
    </div>
    <div class="btn-content">
      <el-button
        type="primary"
        size="small"
        v-if="orderInfo.service_user_id && !orderInfo.start_dt"
        @click="onDispatch(orderInfo, 1)"
      >
        转单
      </el-button>
      <el-button
        type="primary"
        size="small"
        v-if="!orderInfo.service_user_id && orderInfo.state == 2"
        @click="onDispatch(orderInfo, 1)"
      >
        派单
      </el-button>
    </div>
    <el-dialog title="填写派单信息" :visible.sync="showDispatch">
      <el-form :model="form" ref="formName" :rules="rule">
        <el-form-item label="选择商家" label-width="100" prop="companyId">
          <el-select
            :disabled="isCompany"
            v-model="form.companyId"
            placeholder="请选择商家"
            @change="handleSelectChange"
          >
            <el-option
              v-for="item in companyList"
              v-bind:key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="选择保洁员" label-width="100" prop="serviceUserId">
          <el-select v-model="form.serviceUserId" placeholder="请选择保洁员">
            <el-option
              v-for="item in cleanerList"
              v-bind:key="item.id"
              :label="item.realName"
              :value="item.userId"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showDispatch = false">取 消</el-button>
        <el-button type="primary" @click="onConfirmDispatch">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      orderInfo: {},
      showDispatch: false,
      isCompany: window.userInfo.companyId ? true : false, // 是否是商户账号
      form: {
        companyId: window.userInfo.companyId || "",
        serviceUserId: "",
      },
      typeMap: {
        1: "服务订单",
        2: "广场订单",
        3: "回收订单",
      },
      stateList: [
        { value: 1, label: "待付款" },
        { value: 2, label: "待预约" },
        { value: 3, label: "服务中" },
        { value: 4, label: "已完成" },
        { value: 5, label: "退款中" },
        { value: 6, label: "待派单" },
        { value: 7, label: "待服务" },
        { value: 8, label: "服务中" },
      ],
      companyList: [],
      cleanerList: [],
      rule: {
        companyId: [
          { required: true, message: "请选择商家", trigger: "change" },
        ],
        serviceUserId: [
          { required: true, message: "请选择保洁员", trigger: "change" },
        ],
      },
    };
  },
  created() {
    this.orderId = this.$route.query.orderId || "";
    this.getOrderInfo();
    this.getCompanyList();
    this.getCleanerList("0" || window.userInfo.companyId);
  },
  methods: {
    async getOrderInfo() {
      let res = await this.$get("/order/details", { orderId: this.orderId });
      // res.orderProductBoList.forEach((list) => {
      //   if (list.state == 3) {
      //     // 服务中
      //     let { state, cleanerId } =
      //       list.cleanerServiceLogList[list.cleanerServiceLogList.length - 1];
      //     // 服务中
      //     list.status = state == 1 ? (cleanerId ? 7 : 6) : state == 2 ? 8 : 4;
      //   } else {
      //     list.status = list.state;
      //   }
      // });
      console.log(res);
      this.orderInfo = res;
    },
    // 查询保洁公司
    async getCompanyList() {
      let list = await this.$get("/company/all");
      this.companyList = list || [];
    },
    // 查询公司下所有服务人员
    async getCleanerList(id) {
      let res = await this.$post("/company/cleanerListByPage", {
        companyId: id,
        currentPage: 1,
        nowStatus: "2",
        pageSize: 999,
      });
      this.cleanerList = res.list || [];
      this.form.serviceUserId = "";
    },
    // 派单
    onDispatch(item, type) {
      if (type == 1) {
        this.form.orderProductId = item.id;
        this.showDispatch = true;
      } else {
        this.cancelOrder(item);
      }
    },
    // 管理员取消订单
    cancelOrder(order) {
      this.$confirm(
        `确认取消订单 ${this.orderInfo.orderNum}？此操作不可撤销。`,
        "取消订单",
        {
          confirmButtonText: "确定取消",
          cancelButtonText: "取消",
          type: "warning",
        },
      )
        .then(async () => {
          await this.$post("/order/adminCancel", {
            orderId: this.orderInfo.orderId,
          });
          this.$message({ type: "success", message: "订单已取消" });
          this.getOrderInfo();
        })
        .catch(() => {
          this.$message({ type: "info", message: "已取消操作" });
        });
    },
    // 确定指派/转单
    async onConfirmDispatch() {
      this.$refs.formName.validate(async (valid) => {
        if (valid) {
          const selectedCleaner =
            this.cleanerList.find(
              (item) => item.userId === this.form.serviceUserId,
            ) || {};
          await this.$post("/order/transferOrder", {
            id: this.orderInfo.id,
            serviceUserId: selectedCleaner.id,
            serviceUserPhone: selectedCleaner.phone || "",
          });
          this.$message.success("操作成功");
          this.showDispatch = false;
          this.getOrderInfo();
        }
      });
    },
    handleAgreeRefund() {
      this.$confirm("确定同意退款?")
        .then(async () => {
          await this.$post("/pay/refund", { orderId: this.orderInfo.orderId });
          this.$message.success("退款成功");
          this.getOrderInfo();
        })
        .catch((_) => {});
    },
    handleSelectChange(val) {
      this.getCleanerList(val);
    },
  },
};
</script>
<style lang="stylus" scoped>
@import './../../styl/variables.styl'
@import './../../styl/common.styl'
.mt-20 {
  margin-top: 20px
}
.page-order-detail {
  padding: 20px
}
.btn-content {
  display flex
  justify-content center
  margin-top 20px
}
.button-one
  width 50px
  color #fff
  border none
  outline none
  -webkit-appearance none
  text-align center
  border-radius 5px
  background #20a0ff
  height 25px
  margin-right 345px
  margin-left 20px
.table
  width 900px
  font-size 18px

.#p_span
	display block
.Total
  margin 20px
  height 40px
  box-sizing border-box
  position relative
.spans
  position absolute
  display block
  bottom 0px
  right 5px
.bottom
  width 100%
  bottom 0px
.left
  width 50%
  float left
.left ul li
  padding 4px
.right
  width 50%
  float right
.refund
  padding-top 10px
  text-align center
.refunds
  height 30px
  text-align right
 .el-table .warning-row
  background oldlace

.el-table .success-row
  background #f0f9eb
</style>
